import React from 'react'
import { Form } from 'react-bootstrap'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'

const TranscriptTypeahead = ({
  recordings = [],
  isLoading,
  handleSearch,
  handleChange,
}) => {
  return (
    <Form.Group className="d-flex flex-column align-items-start">
      <Form.Label>Find Recording:</Form.Label>
      <Form.Group className="w-100">
        <AsyncTypeahead
          id="transcript-typeahead"
          filterBy={() => true}
          className="w-100"
          labelKey="recordingTitle"
          options={recordings}
          isLoading={isLoading}
          onSearch={handleSearch}
          onChange={handleChange}
          minLength={3}
          placeholder="Enter transcript keyword"
          renderMenuItemChildren={(option, props) => {
            return (
              <div className="vh-1">
                <span>{option.recordingTitle}</span>
              </div>
            )
          }}
        />
      </Form.Group>
    </Form.Group>
  )
}

export default TranscriptTypeahead
